/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ApiErrorDetailsAnyOf } from './apiErrorDetailsAnyOf';

export type ApiErrorDetails = ApiErrorDetailsAnyOf | null;
